import { Component, Input, OnInit } from '@angular/core';
import { RankersService } from '../../../providers/rankings.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-iquanta-toppers-section',
  templateUrl: './iquanta-toppers-section.component.html',
  styleUrls: ['../../rankings/rankings.component.scss'],
  imports: [CommonModule],
  standalone: true,
  providers: [RankersService]
})
export class IquantaToppersSectionComponent implements OnInit{
  rankers2024:any[]=[];
  rankers2023:any[]=[];
  rankers2022:any[]=[];
  rankers2021:any[]=[];
  rankers2020:any[]=[];
  rankers2019:any[]=[];
  rankers2018:any[]=[];
  rankers2017:any[]=[];
  rankers2016:any[]=[];
  rankers2015:any[]=[];
  allToppersList:any[]=[];

  tabVal:any = '2024'
  viewCount: any = 24;
  viewCount1: any = 24;
  viewCount2: any = 24;
  viewCount3: any = 24;
  viewCount4: any = 24;
  viewCount5: any = 24;
  viewCount6: any = 24;
  viewCount7: any = 24;
  viewCount8: any = 24;
  viewCount9: any = 24;

  @Input('pageName') pageName: any;

  toppersListSelected:any[]=[]

  constructor(public constantService: RankersService) { }

  ngOnInit(): void {
    this.rankers2015 = this.constantService.rankers2015;
    this.rankers2016 = this.constantService.rankers2016;
    this.rankers2017 = this.constantService.rankers2017;
    this.rankers2018 = this.constantService.rankers2018;
    this.rankers2019 = this.constantService.rankers2019;
    this.rankers2020 = this.constantService.rankers2020;
    this.rankers2021 = this.constantService.rankers2021;
    this.rankers2022 = this.constantService.rankers2022;
    this.rankers2023 = this.constantService.rankers2023;
    this.rankers2024 = this.constantService.rankers2024;
    this.toppersListSelected = this.constantService.rankers2024;
    this.allToppersList = this.constantService.rankers2023.concat(this.constantService.rankers2022.concat(this.constantService.rankers2021.concat(this.constantService.rankers2020.concat(this.constantService.rankers2019.concat(this.constantService.rankers2018.concat(this.constantService.rankers2017.concat(this.constantService.rankers2016.concat(this.constantService.rankers2015))))))))
    this.allToppersList = this.constantService.rankers2024.concat(this.allToppersList)
    this.allToppersList.sort((a: any, b: any) => a.value > b.value ? -1 : 1)
  }

  changeTab(val:any){
this.tabVal = val;
if(val == 'all'){
  this.toppersListSelected = this.allToppersList;
}else if(val == '2024'){
  this.toppersListSelected = this.constantService.rankers2024;
}else if(val == '2023'){
  this.toppersListSelected = this.constantService.rankers2023;
}else if(val == '2022'){
  this.toppersListSelected = this.constantService.rankers2022;
}else if(val == '2021'){
  this.toppersListSelected = this.constantService.rankers2021;
}else if(val == '2020'){
  this.toppersListSelected = this.constantService.rankers2020;
}else if(val == '2019'){
  this.toppersListSelected = this.constantService.rankers2019;
}else if(val == '2018'){
  this.toppersListSelected = this.constantService.rankers2018;
}else if(val == '2017'){
  this.toppersListSelected = this.constantService.rankers2017;
}else if(val == '2016'){
  this.toppersListSelected = this.constantService.rankers2016;
}else if(val == '2015'){
  this.toppersListSelected = this.constantService.rankers2015;
}
  }

  viewMore(val: any) {
      if (this.viewCount < this.toppersListSelected.length) {
        this.viewCount = this.viewCount + 24;
      }
   
  }

  viewLess(val: any) {
      this.viewCount = 24;
   
  }

}
